module.exports = __webpack_public_path__ + "static/media/vf_mdressshoes_core.be6a34cf.svg";